import { render, staticRenderFns } from "./insideCreatOrder.vue?vue&type=template&id=fa4742d0&scoped=true&"
import script from "./insideCreatOrder.vue?vue&type=script&lang=js&"
export * from "./insideCreatOrder.vue?vue&type=script&lang=js&"
import style0 from "./insideCreatOrder.vue?vue&type=style&index=0&id=fa4742d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4742d0",
  null
  
)

export default component.exports